package pwgs.ui.scenes.projectrootscene


class ProjectRootControllerFe(props: ProjectRootSceneProps, scene: MProjectRootScene) : AProjectRootControllerFe(props, scene) {

    override fun createInitialModel() : ProjectRootSceneModel {
        return ProjectRootSceneModel()
    }

    override fun init() {
        call_load()
    }


}

